import { cva, VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { HTMLAttributes } from 'react'

import { Cross } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'

import Styles from './Banner.module.scss'

const bannerVariants = cva(Styles.bannerBase, {
  variants: {
    state: {
      negative: Styles.negative,
      info: Styles.info,
      normal: Styles.normal
    },
    type: {
      boxed: Styles.boxed,
      plain: Styles.plain
    }
  }
})

interface IBannerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof bannerVariants> {
  showCloseButton?: boolean
  description?: string
  showList?: boolean
  errorList?: string[]
  icon?: React.ReactNode
  onClose?: () => void
}

const Banner: React.FC<IBannerProps> = ({
  className,
  state,
  type,
  description,
  icon,
  showCloseButton,
  showList,
  errorList,
  onClose
}) => {
  return (
    <div
      className={clsx(className, bannerVariants({ state, type }))}
      data-testid="banner">
      {!!icon && <div className={Styles.iconContainer}>{icon}</div>}
      <div className={Styles.contentContainer}>
        <Text variant="nextBody" weight="regular">
          {description}
        </Text>
      </div>
      {showCloseButton && (
        <button className={Styles.closeContainer} onClick={onClose}>
          <Cross width={24} height={24} />
        </button>
      )}
      {showList && (
        <ul className={Styles.list} data-testid="banner-list">
          {errorList?.map((error, index) => (
            <li key={index}>
              <Text variant="nextBody" weight="regular">
                {error}
              </Text>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Banner
